import i18n from "@/config/i18n";
import router from "@/router";
import Axios from "axios";
import Moment from "moment";
import Vue from "vue";

var baseUrl = process.env.VUE_APP_BASEURL + ":" + process.env.VUE_APP_BASEURLPORT + "/api/control/";
if (process.env.NODE_ENV != "development") {
	baseUrl = process.env.VUE_APP_BASEURL;
	window.baseUrl = process.env.VUE_APP_BASEURL;
} else {
	window.baseUrl = process.env.VUE_APP_BASEURL + ":" + process.env.VUE_APP_BASEURLPORT;
}

const instance = Axios.create({
	baseURL: baseUrl,
	timeout: 60000,
});

var helper = {
	callback_error(error, alertMessage = null) {
		const errorMessage = error?.response?.data?.error;
		let shouldAlert = true;

		let currentRoute = router.currentRoute.name;

		if(currentRoute == "login_code" || currentRoute == "mobile_login_code"){
			shouldAlert = false;
		}

		switch (errorMessage) {
			case "Invalid subdomain":
				window.location.href = "https://pagstream.com/ps/#/login";
				return;
			case "Empty subscriptions":
				alertMessage = "Erro! Nenhuma assinatura encontrada com este e-mail."
			case "Token expired":
				if(currentRoute != "login_code" && currentRoute != "mobile_login_code"){
					const query = router.currentRoute.query;
					router.push({ name: "login", query }).catch(() => {});
				}
				break;
		}

		if (shouldAlert) {
			if(!alertMessage) {
				alertMessage = "Ops! Algo deu errado.";
			}

			Vue.$toast.error(alertMessage, { position: "top" });
		}
	},

	axios() {
		return instance;
	},

	formatDate(valor, format = 1) {
		let split;

		if (typeof valor == "undefined" || valor == null) {
			return "";
		}

		if (format == 1 && valor != "" && valor != null) {
			if (valor.indexOf("-") != -1) {
				split = "-";
			} else {
				split = "/";
			}

			let info = valor.split(split);

			if (info[2].length < 4) {
				// provavelmente o formato é YYYY-MM-DD
				valor = Moment(valor, "YYYY" + split + "MM" + split + "DD");
			} else {
				// provavelmente o formato é MM-DD-YYYY
				valor = Moment(valor, "MM" + split + "DD" + split + "YYYY");
			}

			info = valor.format("DD/MM/YYYY");

			return info;
		} else {
			// Quando o dado vem através do miva, ele já vem formatado com MM/DD/YYYY
			// Entretanto, quando vem via mysql, ele vem como YYYY-MM-DD, e precisa ser formatado
			if (valor.indexOf("-") == -1) {
				return valor;
			}

			valor = Moment(valor, "YYYY-MM-DD");
			let info = valor.format("MM/DD/YYYY");

			return info;
		}
	},

	formatTimestamp(valor, format = 1) {
		let info;
		if (format == 1 && valor != "" && valor != null) {
			// provavelmente o formato é YYYY-MM-DD
			valor = Moment(valor, "YYYY-MM-DD HH:mm:ss");

			info = valor.format("DD/MM/YYYY HH:mm:ss");

			return info;
		} else {
			// Quando o dado vem através do miva, ele já vem formatado com MM/DD/YYYY
			// Entretanto, quando vem via mysql, ele vem como YYYY-MM-DD, e precisa ser formatado
			if (valor.indexOf("-") == -1) {
				return valor;
			}

			valor = Moment(valor, "YYYY-MM-DD HH:mm:ss");
			let info = valor.format("MM/DD/YYYY HH:mm:ss");

			return info;
		}
	},

	formatValue(valor, format = 1) {
		let ret;

		if (typeof valor == "undefined" || valor == null) {
			return "";
		}

		if (format == 1) {
			if (valor == "") {
				valor = 0.0;
			}

			ret = parseFloat(valor);
			ret = ret.format(2, 3, ".", ",");

			return ret;
		} else {
			if (valor == "") {
				valor = 0.0;
			}

			ret = parseFloat(valor);
			ret = ret.format(2, 3, ",", ".");

			return ret;
		}
	},

	translateInterval(val, qtde) {
		let options;

		if(qtde > 1){
			options = {
				"DAY": i18n.t("days"),
				"WEEK": i18n.t("weeks"),
				"MONTH": i18n.t("months"),
				"QUARTER": i18n.t("quarters"),
				"YEAR": i18n.t("years"),
			}
		}else{
			options = {
				"DAY": i18n.t("day"),
				"WEEK": i18n.t("week"),
				"MONTH": i18n.t("month"),
				"QUARTER": i18n.t("quarter"),
				"YEAR": i18n.t("year"),
			}
		}

		return options[val] ?? "";
	},

	popup(popup, URL) {
		popup.location.href = URL;
	},

	isDark(bgColor) {
		if (bgColor == null || bgColor == '') {
			return false;
		}

		const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;

		const r = parseInt(color.substring(0, 2), 16);
		const g = parseInt(color.substring(2, 4), 16);
		const b = parseInt(color.substring(4, 6), 16);

		return (((r * 0.299) + (g * 0.587) + (b * 0.114)) <= 186);
	},

	sanitizeUtfmb4(value) {
		if (typeof value !== "string") {
			return value;
		}

		/* Remove todos os caracteres que não são letras, números, espaços ou pontuação. */
		return value.replace(
			/[^\x20-\x7E\xC0-\xC3\xC7\xC9-\xCA\xCD\xD3-\xD5\xDA\xE0-\xE3\xE7\xE9-\xEA\xED\xF3-\xF5\xFA]/g,
			""
		);
	}
};

export default helper;
